import { theme } from 'appCore';

export default {
  firstInAll: {
    width: 200,
    height: 200,
    backgroundColor: theme.colors.primary
  }
};
